<template>
  <BlockUI>
    <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
  </BlockUI>
</template>

<script>
import TokenService from "/src/core/services/tokenservice";
import { router } from "@/router";

export default {
  name: "App",
  mounted() {
    window.addEventListener("message", this.receiveToken);
    if (this.IsFrame()) {
      setTimeout(() => {
        window.parent.postMessage("IframeIsReady", "*");
      }, 1000);
    } else {
      router.push("/401");
    }
  },
  methods: {
    receiveToken(event) {
      try {
        var data = JSON.parse(event.data);
        if (data && data.action == "GetAccessToken") {
          TokenService.setUser(data.user);

          // فقط ریدایرکت کن اگر مقصد با مسیر فعلی فرق داشته باشه
          if (router.currentRoute.path !== data.user.url) {
            router.push(data.user.url);
          } else {
            console.log("Already on the destination route");
          }
        }
      } catch (e) {
        //var postMessageParams = {
        // action: "RefreshParentFromIframe"
        // }
        //window.addEventListener("message", postMessageParams, false);
      }
    },

    IsFrame() {
      let windowLen = window.frames.length;
      let parentLen = parent.frames.length;
      if (windowLen == 0 && parentLen >= 1) {
        // The page is in an iFrames
        return true;
      } else {
        // The page is not in an iFrame
        return false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveToken);
  },
};
</script>
